<script lang="ts" setup>
import { ref, watch, type PropType } from "vue";
import { BreadcrumbType } from "@/app/common/types/breadcrumb.type";

const prop = defineProps({
  title: {
    type: String,
    default: ""
  },
  items: {
    type: Array as PropType<BreadcrumbType[]>,
    default: () => []
  },
  isStep: {
    type: Boolean,
    default: false
  },
  summary: {
    type: Object,
    default: {},
  }
});

const localItems = ref(prop.items as BreadcrumbType[]);

watch(
  () => prop.items,
  () => {
    localItems.value = prop.items;
  },
  {
    immediate: true,
    deep: true,
  },
);
</script>
<template>
  <v-row class="app-breadcrumb d-flex justify-space-between align-center"
    :class="{ 'app-breadcrumb--step': isStep }">
    <v-col class="breadcrumb-title">
      <h2 class="text-uppercase font-weight-bold">
        {{ title }}
      </h2>
    </v-col>
    <v-col>
      <v-breadcrumbs :items="localItems" class="breadcrumb-wrapper justify-end"
        :class="{ 'breadcrumb-wrapper--step': isStep }">
        <template v-slot:title="{ item, index }">
          <div v-if="localItems[index].stepNo" :class="isStep ? 'step' : ''" class="d-flex align-center">
            <v-avatar v-if="localItems[index].stepNo < localItems.filter(o => o.active).length" size="x-small"
              class="mr-2" :class="localItems[index].active ? 'active' : ''">
              <v-icon icon="mdi mdi-check"></v-icon>
            </v-avatar>
            <v-avatar v-else size="x-small" class="mr-2" :class="localItems[index].active ? 'active' : ''">
              <span>{{ localItems[index].stepNo }}</span>
            </v-avatar>
            <span :class="localItems[index].active ? 'active' : ''">{{ $t(`t-${item.title}`) }}</span>
          </div>
          <div v-else-if="summary">
            {{ summary.text }} {{ localItems[index].total }} {{ summary.unit }}
          </div>
          <div v-else-if="localItems[index].title" class="d-flex align-center">
            {{ $t(`t-${localItems[index].title}`) }}
          </div>
        </template>
        <template #divider="{ index }">
          <div v-if="localItems[index].stepNo" style="border-top: 1px solid white; width: 50px;"></div>
          <div></div>
        </template>
      </v-breadcrumbs>
    </v-col>
  </v-row>
</template>
